import { Link, useSearchParams } from "react-router-dom";
import { ArrowLeft, Phone, Mail, Globe, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { distributors } from "@/data/distributors";
import { useLanguage } from "@/contexts/LanguageContext";
import { LanguageSelector } from "@/components/LanguageSelector";

const WhereToBuy = () => {
  const { t } = useLanguage();
  const [searchParams] = useSearchParams();
  const region = searchParams.get("region");

  return (
    <div className="relative min-h-screen bg-[hsl(210,30%,12%)]">
      <div className="absolute top-4 right-4 z-20">
        <LanguageSelector />
      </div>

      {/* Header */}
      <div className="container mx-auto px-4 pt-6 pb-4">
        <Link to="/home">
          <Button variant="ghost" className="text-white/80 hover:text-white hover:bg-white/10 mb-4">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back
          </Button>
        </Link>
        <div className="text-center mb-6">
          <img
            src="/lovable-uploads/aurora-logo-white-green.png"
            alt="Aurora Logo"
            className="w-36 h-auto mx-auto mb-4"
          />
          <h1 className="text-3xl md:text-4xl font-bold text-white tracking-tight">
            Where To Buy{region ? ` – ${region}` : ""}
          </h1>
          <p className="text-white/60 mt-2">
            Find an authorised Aurora customer{region ? ` in ${region}` : " near you"}
          </p>
        </div>
      </div>

      {/* Distributor List */}
      <div className="container mx-auto px-4 pb-8">
        <div className="max-w-5xl mx-auto grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {distributors
            .filter((dist) => !region || dist.region === region)
            .map((dist) => (
            <Card
              key={dist.id}
              className="p-4 transition-all border border-white/10 bg-white/5 hover:bg-white/10 hover:border-white/20"
            >
              <h4 className="font-semibold text-white">{dist.name}</h4>
              {dist.territories && (
                <p className="text-xs text-primary/80 mt-1">{dist.territories}</p>
              )}
              {dist.address && <p className="text-sm text-white/70 mt-2">{dist.address}</p>}
              <p className="text-sm text-white/70">{dist.phone}</p>
              {dist.email && (
                <a href={`mailto:${dist.email}`} className="text-sm text-primary/80 hover:text-primary flex items-center gap-1 mt-1">
                  <Mail className="h-3 w-3" /> {dist.email}
                </a>
              )}
              {dist.website && (
                <a href={dist.website} target="_blank" rel="noopener noreferrer" className="text-sm text-primary/80 hover:text-primary flex items-center gap-1 mt-1">
                  <Globe className="h-3 w-3" /> Visit Website
                </a>
              )}
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhereToBuy;
